<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item style="width:22%">
          <el-date-picker v-model="order.date" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="orderisselect = true" :unlink-panels="false"
            style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item style="width:12%">
          <el-select v-model="order.send" clearable placeholder="请选择发货仓库" @change="orderisselect = true">
            <el-option v-for="(item, index) in wareHouseLists" :label="item.name" :value="item.id"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width:12%">
          <el-select v-model="order.delivery" clearable placeholder="请选择收货仓库" @change="orderisselect = true">
            <el-option v-for="(item, index) in wareHouseLists" :label="item.name" :value="item.id"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width:14%">
          <el-input placeholder="请输入订单号" v-model="order.key" clearable style="width:100%"
            @change="orderisselect = true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" icon="el-icon-search" @click="getOrderlists">查询</el-button>
          <el-button type="warning" @click="addnews"
            v-if="actionauth.order_allot_add == 'true'">新增</el-button>
        </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
        <el-table :data="orderlists" style="width: 100%" v-loading="orderListLoading">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.goods">
                <el-table-column prop="name" label="商品名称" min-width="250">
                  <template slot-scope="scope">
                    <span style="font-size:13px;line-height:23px;display:inline-block;width:100%">{{ scope.row.name
                      }}</span>
                    <span style="font-size:12px;color:#999999;line-height:23px;">编号：{{ scope.row.number }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="num" label="数量" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span style="font-size:13px">{{ scope.row.num }}</span>
                  </template>
                </el-table-column>
                

                <el-table-column prop="unit" label="单位" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span style="font-size:13px">{{ scope.row.unit }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="storageLocationStatus" prop="from_storage_location_code" label="调出货位" min-width="150" align="center">
                </el-table-column>
                <el-table-column v-if="storageLocationStatus" prop="to_storage_location_code" label="调入货位" min-width="150" align="center">
                </el-table-column>
                <el-table-column v-if="batchStatus" prop="unit" label="批次号" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span style="font-size:13px">{{ scope.row.batch_sn }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="batchStatus" prop="unit" label="生产日期" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span style="font-size:13px" v-if="scope.row.start_date && scope.row.start_date != '0'">{{ scope.row.start_date }}</span>
                    <span v-else>/</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="batchStatus" prop="unit" label="保质期" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span style="font-size:13px">{{ scope.row.realvalidity }}{{ validityunitTemp[scope.row.validityunit] }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="batchStatus" prop="unit" label="到期日期" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span style="font-size:13px" v-if="scope.row.end_date && scope.row.end_date != '0'">{{ scope.row.end_date }}</span>
                    <span v-else>/</span>
                  </template>
                </el-table-column>
                <el-table-column prop="sell" label="价格" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span style="font-size:13px">{{ scope.row.sell }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="total" label="合计" min-width="150" align="center">
                  <template slot-scope="scope">
                    <span style="font-size:13px">{{ scope.row.total }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="调拨单号" prop="documents" align="center" min-width="150">
            <template slot-scope="scope">
              <span style="font-size:14px">{{ scope.row.documents }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发货仓库 - 收货仓库" prop="send" align="left" min-width="150">
            <template slot-scope="scope">
              <div style="display:flex;justify-content:left;align-items:center;">
                <span style="font-size:13px;">{{ scope.row.send }}</span>
                <img src="../../assets/sellicon/line-right.png" style="width:15px;height:15px;padding:0 10px;" />
                <span style="font-size:13px">{{ scope.row.delivery }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="订单时间" prop="inputtime" align="center" min-width="150">
            <template slot-scope="scope">
              <span style="font-size:13px">{{ scope.row.inputtime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="note" align="center" min-width="150">
            <template slot-scope="scope">
              <span style="font-size:13px">{{ scope.row.note }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center" min-width="150">
            <template slot-scope="scope">
              <span style="font-size:13px">{{ scope.row.status == 0 ? '已完成' : '已删除' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作人" prop="managername" align="center" min-width="150">
            <template slot-scope="scope">
              <span style="font-size:13px">{{ scope.row.managername }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="150">
            <template slot-scope="scope">
              <el-button type="warning" size="small" round @click="showorder(scope.row)">查看订单</el-button>
              <!-- <el-button type="" size="small" round @click="delCurrent(scope.row)" v-if="scope.row.status==0">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="orderPageSizeChange" @current-change="orderPageCurrentChange"
            :current-page="order.p" :page-sizes="[10, 20, 50]" :page-size="order.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="total_order_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <el-dialog title="添加库存调拨" :visible.sync="addallotDialog" top="3vh" width="90%">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item style="width:15%">
            <el-select v-model="create.send" placeholder="发货仓库" style="width:100%">
              <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"
                v-if="lists == ''"></el-option>
              <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"
                v-if="lists != '' && create.send != item.id" disabled></el-option>
              <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"
                v-if="lists != '' && create.send == item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item ref="search" :model="search">
            <el-input placeholder="请输入条形码" v-model="productquery.key" @keyup.enter.native="addDialogsingle">
              <template slot="prepend">查找</template>
              <el-button slot="append" icon="el-icon-search" @click="addDialogShow"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addDialogShow">批量添加</el-button>
          </el-form-item>
        </el-form>
        <el-col :span="24">
          <el-col :span="24">
            <template>
              <el-table :data="lists" v-loading="listLoading" border show-summary>
                <el-table-column prop="number" label="编号" width="90" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.number }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称">
                  <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="spec" label="规格" width="90" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.spec }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位" width="90" align="center">
                  <template slot-scope="scope">
                    <el-input size="small" :value="scope.row.unit" readonly @focus="changeUnit(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="num" label="数量" width="90" current-row-key="getindex" align="center">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="nums[scope.$index]"
                      @blur="changeNum(scope.$index, scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="sell" label="售价" width="110" align="center"></el-table-column>
                <el-table-column prop="total" label="小计" width="110" align="center">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="totals[scope.$index]"
                      @blur="changeTotal(scope.$index, scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="70" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-delete" @click="deltempCurrent(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-col>
          <el-col :span="24">&nbsp;</el-col>
          <el-col :span="24">
            <div
              style="border:1px solid #ebeef5;background:#ebeef5;border-radius:6px;padding:20px;margin-bottom:20px;float:left">
              <el-form ref="create" :model="create" label-width="70px" size="small">
                <el-col :span="6">
                  <el-form-item label="发货仓库" style="width:90%">
                    <el-select v-model="create.send" placeholder="请选择发货仓库">
                      <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name"
                        :value="item.id" v-if="lists == ''"></el-option>
                      <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name"
                        :value="item.id" v-if="lists != '' && create.send != item.id" disabled></el-option>
                      <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name"
                        :value="item.id" v-if="lists != '' && create.send == item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="收货仓库" style="width:90%">
                    <el-select v-model="create.delivery" placeholder="请选择收货仓库">
                      <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="调拨日期" style="width:90%">
                    <el-date-picker type="date" placeholder="请选择付款日期" v-model="create.allotdate" style="width:99%;"
                      value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="单据编号" style="width:90%">
                    <el-input v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="备注" style="width:90%">
                    <el-input placeholder="备注" v-model="create.note"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-col>
        </el-col>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addallotDialog = false">取 消</el-button>
          <el-button size="small" type="danger" :loading="createsaveloading" @click="createSave">保存</el-button>
        </div>
      </el-dialog>

      <!---------------------------修改单位--------------------------->
      <el-dialog title="单位选择" :visible.sync="unitDialog">
        <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
          <el-table-column label="单位" prop="unit">
          </el-table-column>
          <el-table-column label="售价" prop="sell">
          </el-table-column>
          <el-table-column label="市场价" prop="market">
          </el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" circle icon="el-icon-check"
                @click="changeUnitSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!--------------------------------修改单位end--------------------------->

      <!---------------------------批量添加--------------------------->
      <el-dialog title="添加产品" :visible.sync="addDialog" width="60%" top="1vh">
        <!------------------------search---------------------->
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item style="width:15%">
            <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="selectbrand">
              <el-option label="不分品牌" value="0"></el-option>
              <el-option v-for="(item, index) in brandlists" :label="item.name" :value="item.id"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item ref="productquery" :model="productquery">
            <el-input placeholder="商品名称 / 编号 / 条形码 / 拼音码" v-model="productquery.key" clearable
              @keyup.enter.native="getProductList(create.send)" @change="isnewselect = true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getProductList(create.send)">查询</el-button>
          </el-form-item>
        </el-form>
        <!------------------------search end---------------------->
        <el-table :data="productlists" ref="multipleTable" style="width: 100%" v-loading="addListLoading"
          tooltip-effect="dark" @row-click="handleSelectRow" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="number" label="编号" width="80"></el-table-column>
          <el-table-column prop="brandname" label="品牌" width="80"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="spec" label="规格" width="120"></el-table-column>
          <el-table-column label="库存" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.inventory > 0">{{ scope.row.inventory }}</span>
              <span v-if="scope.row.inventory == 0" style="color:#F56C6C">{{ scope.row.inventory }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="productPageSizeChange" @current-change="productPageCurrentChange"
            :current-page="productquery.p" :page-sizes="[10, 20, 50]" :page-size="productquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="total_product_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addDialog = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="addProductLoading" @click="addSave">确认添加</el-button>
        </div>
      </el-dialog>
      <!--------------------------------批量添加end--------------------------->

      <!--------------------------------打印--------------------------->
      <el-dialog title="确认打印" :visible.sync="printerDialog" width="80%" top="10vh">
        <div style="width:100%;text-align:right">
          <span v-if="printorderdetail.printnumber > 0" style="float:left;color:#E6A23C">本订单已打印
            {{ printorderdetail.printnumber }} 次</span>
          每页展示 <input type="text" v-model="rollpage" v-on:blur="changepagevlaue()"
            style="border-radius:5px;border:1px solid rgb(192, 196, 204);background-color:#fff;color:#606266;width:25px;height:30px;line-height:40px;padding:0 15px;margin-bottom:20px" />
          条
        </div>
        <div id="printContent" v-loading="printLoading">
          <div v-for="(iit, i) in prpage">
            <span style="float:right">{{ iit.id }}/{{ allprintpage }}</span>
            <DIV style="LINE-HEIGHT:30px;font-size:18px;padding-bottom:2px;" align="center"
              v-if="printsmodel.title == 1">
              <STRONG>{{ printsmodel.titlevalue }}</STRONG>
            </DIV>
            <ul class="titlelists">
              <li v-if="printsmodel.allocate_date == 1">调拨日期：{{ printorderdetail.allotdate }}</li>
              <li v-if="printsmodel.f_warehourse == 1">发货仓库：{{ printorderdetail.sendName }}</li>
              <li v-if="printsmodel.s_warehourse == 1">收货仓库：{{ printorderdetail.deliveryName }}</li>
              <li v-if="printsmodel.documents == 1">单据编号：{{ printorderdetail.documents }}</li>
              <li v-if="printsmodel.note == 1">备注：{{ printorderdetail.note }}</li>
            </ul>
            <TABLE border=1 cellSpacing=0 cellPadding=1 width="100%"
              style="border-collapse:collapse;margin-top:5px;font-size:15px" bordercolor="#333333">
              <TR class="contactcontent">
                <TD v-if="printsmodel.number == 1">
                  <DIV align=center><b>编号</b></DIV>
                </TD>
                <TD v-if="printsmodel.product_name == 1">
                  <DIV align=center><b>品名</b></DIV>
                </TD>
                <TD v-if="printsmodel.product_spec == 1">
                  <DIV align=center><b>规格</b></DIV>
                </TD>
                <TD v-if="printsmodel.unit == 1">
                  <DIV align=center><b>单位</b></DIV>
                </TD>
                <TD v-if="printsmodel.transfer_out_storage_location == 1 && storageLocationStatus">
                  <DIV align=center><b>调出货位</b></DIV>
                </TD>
                <TD v-if="printsmodel.transfer_to_storage_location == 1 && storageLocationStatus">
                  <DIV align=center><b>调入货位</b></DIV>
                </TD>
                <TD v-if="printsmodel.batch_sn == 1 && batchStatus">
                  <DIV align=center><b>批次号</b></DIV>
                </TD>
                <TD v-if="printsmodel.start_date == 1 && batchStatus">
                  <DIV align=center><b>生产日期</b></DIV>
                </TD>
                <TD v-if="printsmodel.realvalidity == 1 && batchStatus">
                  <DIV align=center><b>有效期</b></DIV>
                </TD>
                <TD v-if="printsmodel.end_date == 1 && batchStatus">
                  <DIV align=center><b>到期日期</b></DIV>
                </TD>
                <TD v-if="printsmodel.num == 1">
                  <DIV align=center><b>数量</b></DIV>
                </TD>
                <TD v-if="printsmodel.purchase == 1">
                  <DIV align=center><b>售价</b></DIV>
                </TD>
                <TD v-if="printsmodel.account == 1">
                  <DIV align=center><b>小计</b></DIV>
                </TD>
              </TR>
              <tr v-for="(item, index) in printorderdetail.goods" :key="index" class="contactcontent"
                v-if="index >= prollpage[i]['startpage'] && index <= prollpage[i]['endpage']">
                <TD v-text="item.number" align="center" v-if="printsmodel.number == 1"></TD>
                <TD v-text="item.name" style="padding-left:20px" v-if="printsmodel.product_name == 1"></TD>
                <TD v-text="item.spec" align="center" v-if="printsmodel.product_spec == 1"></TD>
                <TD v-text="item.unit" align="center" v-if="printsmodel.unit == 1"></TD>
                <TD v-text="item.from_storage_location_code" align="center" v-if="printsmodel.transfer_out_storage_location == 1 && storageLocationStatus"></TD>
                <TD v-text="item.to_storage_location_code" align="center" v-if="printsmodel.transfer_to_storage_location == 1 && storageLocationStatus"></TD>
                <TD v-text="item.batch_sn" align="center" v-if="printsmodel.batch_sn == 1 && batchStatus"></TD>
                <TD align="center" v-if="printsmodel.start_date == 1  && batchStatus">
                  <span>{{ item.start_date || '/' }}</span>
                </TD>
                <TD align="center" v-if="printsmodel.realvalidity == 1 && batchStatus">{{ item.realvalidity }}{{ validityunitTemp[item.validityunit] }}</TD>
                <TD align="center" v-if="printsmodel.realvalidity == 1 && batchStatus">
                  <span>{{ item.end_date || '/' }}</span>
                </TD>
                <TD v-text="item.num" align="center" v-if="printsmodel.num == 1"></TD>
                <TD v-text="item.sell" align="center" v-if="printsmodel.purchase == 1"></TD>
                <TD v-text="item.total" align="center" v-if="printsmodel.account == 1"></TD>
              </tr>
              <tr v-if="iit.id == allprintpage">
                <TD align="center" v-if="printsmodel.number == 1 || printsmodel.product_name == 1"><b>合计</b></TD>
                <TD v-if="printsmodel.number == 1 && printsmodel.product_name == 1"></TD>
                <TD v-if="printsmodel.product_spec == 1">&nbsp;</TD>
                <TD v-if="printsmodel.unit == 1">&nbsp;</TD>
                <TD v-if="printsmodel.transfer_out_storage_location == 1 && storageLocationStatus">&nbsp;</TD>
                <TD v-if="printsmodel.transfer_to_storage_location == 1 && storageLocationStatus">&nbsp;</TD>
                <TD v-if="printsmodel.batch_sn == 1 && batchStatus">&nbsp;</TD>
                <TD v-if="printsmodel.start_date == 1 && batchStatus">&nbsp;</TD>
                <TD v-if="printsmodel.realvalidity == 1 && batchStatus">&nbsp;</TD>
                <TD v-if="printsmodel.end_date == 1 && batchStatus">&nbsp;</TD>
                <TD v-if="printsmodel.num == 1">&nbsp;</TD>
                <TD v-if="printsmodel.purchase == 1">&nbsp;</TD>
                <TD align="center" v-if="printsmodel.account == 1">{{ printorderdetail.total }}</TD>
              </tr>
            </table>
            <TABLE border=0 cellSpacing=0 cellPadding=0 width="100%" style="margin-top:2px;font-size:15px">
              <TBODY>
                <TR class="contactcontent">
                  <TD v-if="printsmodel.inputtime == 1">录单日期：{{ printorderdetail.allotdate }}</TD>
                  <TD v-if="printsmodel.sysmanagername == 1">操作人：{{ printorderdetail.sysmanagername }}</TD>
                </tr>
              </TBODY>
            </TABLE>
            <div class="pageBreak"></div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="printerDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="createnoSave" :loading="printorderLoading">打印</el-button>
        </div>
      </el-dialog>
      <!--------------------------------打印end--------------------------->
    </div>
  </transition>
</template>

<script>

export default {
  data() {
    return {
      url: this.GLOBAL.domain + "Allot/index",
      transitionshow: true,
      actionauth: [],
      lists: [],
      orderisselect: false,
      listLoading: false,
      total_order_rows: 0,
      orderListLoading: false,
      orderlists: [],
      order: {
        act: 'getorderlists',
        token: this.$cookies.get('token'),
        date: '',
        send: '',
        delivery: '',
        key: '',
        p: 1,
        rollpage: 10
      },
      search: {
        act: 'barcode',
        token: this.$cookies.get('token'),
        key: '',
        warehouse: ''
      },
      query: {
        act: 'lists',
        token: this.$cookies.get('token'),
        rollpage: 1000, // 页大小
        p: 1
      },
      total_rows: 0,
      wareHouseLists: [],
      nums: [],
      totals: [],
      validitys: [],
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        send: '',
        delivery: '',
        allotdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        documents: '',
        inputdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        note: '',
      },
      unitLoading: false,
      unitDialog: false,
      unitlists: [],
      unitListLoading: false,
      changeunitid: 0,
      addDialog: false,
      addListLoading: false,
      productquery: {
        act: 'getproduct',
        token: this.$cookies.get('token'),
        brandid: '',
        warehouse: '',
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
      productlists: [],
      brandlists: [],
      total_product_rows: 0,
      addProductLoading: false,
      multipleSelection: [],
      printerDialog: false,
      deliveryName: '',
      sendName: '',
      totalPrice: '',
      printsmodel: [],
      isnewselect: false,

      prpage: [],
      prollpage: [],
      prtotal: 0,
      rollpage: '',
      allprintpage: '',
      addallotDialog: false,
      printLoading: false,
      printorderdetail: [],
      printorderLoading: false,
      createsaveloading: false,
      storageLocationStatus: false, // 货位功能开关
      batchStatus: false,
      validityunitTemp: {
        1: '日',
        2: '月',
        3: '年'
      },
    }
  },


  mounted() {
    this.getactionauth(); //获取权限设置
    this.getOrderlists(); //获取销售订单列表
    this.getWarehouse();
    this.setDocuments();
    this.getprintsmodel();
    this.getWarehouseid();
  },

  created() {
    // 获取货位功能是否开启状态
    this.storageLocationStatus = localStorage.getItem("storageLocationStatus") === 'true'
    this.batchStatus = localStorage.getItem('batchStatus') === 'true'
  },
  methods: {


    /** 重置表单 **/
    reset() {
      this.$refs.create.resetFields();
    },

    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    //获取订单信息列表
    getOrderlists() {
      if (this.orderisselect == true) {
        this.order.p = 1;
        this.order.rollpage = 10;
      }

      this.orderListLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.order).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.orderListLoading = false;
        } else {
          this.orderlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_order_rows = parseInt(res.data.count);
          this.orderListLoading = false;
          if (this.orderisselect == true) this.orderisselect = false;

          //打印完成刷新页面时重新加载参数
          if (this.$cookies.get('print_back_data_Allot') && this.$cookies.get('print_back_data_Allot') != '') {
            var data = this.$cookies.get('print_back_data_Allot');
            data = JSON.parse(data);
            this.orderisselect = data.orderisselect;
            this.order = data.order;
            this.$cookies.set('print_back_data_Allot', '');
            this.getOrderlists();
          }

        }
      }).catch((res) => {
        this.orderListLoading = false;
      });
    },

    orderPageSizeChange(val) {
      this.order.rollpage = val;
      this.getOrderlists();
    },
    orderPageCurrentChange(val) {
      this.order.p = val;
      this.getOrderlists();
    },


    /** 进货单号 **/
    setDocuments() {
      var currentDate = new Date();
      var month = currentDate.getMonth() + 1;
      var doc = 'DB' + currentDate.getFullYear() + month + currentDate.getDate() + currentDate.getHours() + currentDate.getMinutes();
      this.create.documents = doc;
    },


    /** 获取仓库 **/
    getWarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 信息列表 **/
    getList() {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          if (this.lists != '') this.create.send = this.lists[0]['warehouseid'];
          const _this = this;
          this.lists.forEach(function (e, index) {
            _this.nums.splice(index, 1, e.num);
            _this.totals.splice(index, 1, e.total);
            _this.validitys.splice(index, 1, e.validity);
          });
          this.total_rows = parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },
    pageSizeChange(val) {
      this.query.rollpage = val;
      this.getList();
    },
    pageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },


    /** 获取发货仓库id **/
    getWarehouseid() {

    },


    /** 修改单位 **/
    changeUnit(item) {
      this.unitDialog = true;
      this.unitListLoading = true;
      this.changeunitid = item.id;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getunit', productid: item.productid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitlists = JSON.parse(Base64.decode(res.data.Data));
          this.unitListLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
    },


    /** 确认修改单位 **/
    changeUnitSave(item) {
      this.unitListLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeunit', id: item.id, tempid: this.changeunitid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
          this.getList();
        } else {
          this.unitListLoading = false;
          this.$message.success("修改单位信息成功！");
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
      this.unitDialog = false;
    },


    /** 修改数量 **/
    changeNum(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changenum', id: item.id, num: this.nums[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.getList();
        } else {
          this.$message.success('修改商品数量成功！');
          this.listLoading = false;
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },


    /** 修改总价 **/
    changeTotal(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changetotal', id: item.id, total: this.totals[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.listLoading = false;
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },


    /** 删除 **/
    deltempCurrent(item) {
      this.$confirm('此操作将删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' })
        .then(() => {
          // 向请求服务端删除
          var resource = this.$resource(this.url);
          resource.save({ act: 'del', id: item.id, token: this.$cookies.get('token') })
            .then((res) => {
              if (res.data.Result > 0) {
                if (res.data.Result == '70001') {
                  this.$router.push('/login')
                }
                this.$message.error(res.data.Message);
              } else {
                this.$message.success('成功删除了' + item.name + '!');
                this.getList();
              }
            }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
            });
        })
        .catch(() => {
          this.$message.info('已取消操作!');
        });
    },


    /** 扫码添加商品 **/
    addDialogsingle() {
      if (this.create.send == '' || this.create.send == null) {
        this.$message.error('请先选择发货仓库！');
        return false;
      }
      var resource = this.$resource(this.url);
      resource.query({ act: 'sweep', key: this.productquery.key, warehouse: this.create.send, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          if (Base64.decode(res.data.Data) == 1) { //有1个以上则展开列表 
            this.addDialogShow();
            this.productquery.key = '';
          } else { //扫码解析同一个产品只有1个则直接添加
            this.multipleSelection = [];
            this.multipleSelection.push(JSON.parse(Base64.decode(res.data.Data)));
            this.addSave();
            this.productquery.key = '';
          }
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 批量添加 **/
    addDialogShow() {
      if (this.create.send == '' || this.create.send == null) {
        this.$message.error('请先选择发货仓库！');
        return false;
      }
      this.getBrand();
      this.getProductList(this.create.send);
      this.addDialog = true;
    },


    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 产品信息列表 **/
    getProductList(warehouse) {
      if (this.isnewselect == true) {
        this.productquery.p = 1;
        this.productquery.rollpage = 10;
      }

      this.addListLoading = true;
      var resource = this.$resource(this.url);
      this.productquery.warehouse = warehouse;
      resource.query(this.productquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.addListLoading = false;
        } else {
          this.productlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_product_rows = parseInt(res.data.count);
          this.addListLoading = false;
        }

        if (this.isnewselect == true) this.isnewselect = false;
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.addListLoading = false;
        if (this.isnewselect == true) this.isnewselect = false;
      });
    },

    productPageSizeChange(val) {
      this.productquery.rollpage = val;
      this.getProductList(this.create.send);
    },
    productPageCurrentChange(val) {
      this.productquery.p = val;
      this.getProductList(this.create.send);
    },


    /** 确认添加产品到购物车 **/
    addSave() {
      this.addProductLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'addproduct', productid: this.multipleSelection, warehouseid: this.create.send, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addProductLoading = false;
        } else {
          this.$message.success(res.data.Message);
          this.addDialog = false;
          this.addProductLoading = false;
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.addDialog = false;
        this.addProductLoading = false;
      });
    },


    /** 点击单行选择产品 **/
    handleSelectRow(row, event, column) {
      var _this = this;
      var val = [];
      val.push(row);
      var number = 0;
      var id = row.id;
      var isin = [];

      this.productlists.forEach(function (e, index) {
        if (e.id == id) number = index;
      });
      this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);
      this.multipleSelection.forEach(function (e, index) { isin.push(e.id) });

      //检测是否添加产品进购物车
      if (inArray(id, isin)) {
        this.multipleSelection.forEach(function (e, index) {
          if (e.id == id) this.multipleSelection.splice(index, 1);
        });
      } else {
        this.multipleSelection.push(row);
      }

    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },


    /** 新增 **/
    createSave() {
      this.createsaveloading = true;
      var resource = this.$resource(this.url);
      //实时获取单据编号
      this.setDocuments();

      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.createsaveloading = false;
        } else {
          this.$message.success(res.data.Message);
          this.addallotDialog = false;
          this.createsaveloading = false;
          this.setDocuments(); //更新单据编号
          this.getOrderlists(); //刷新订单信息
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.addallotDialog = false;
        this.createsaveloading = false;
      });
    },


    /** 获取仓库名称 **/
    getSendName(id) {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'getname', id: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.sendName = res.data.Message;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取仓库名称 **/
    getDeliveryName(id) {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'getname', id: id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.deliveryName = res.data.Message;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取总价 **/
    getTotal() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'gettotal', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.totalPrice = res.data.Message;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 新增并且打印 **/
    createPrint() {
      if (this.create.send == '') { this.$message.error('请选择发货仓库'); return false; }
      if (this.create.send == this.create.delivery) { this.$message.error('发货仓库不能和收货仓库相同'); return false; }
      if (this.create.delivery == '') { this.$message.error('请选择收货仓库'); return false; }
      if (this.lists == '') { this.$message.error('请选择确认调拨的商品'); return false; }

      this.printerDialog = true;
      this.getSendName(this.create.send);
      this.getDeliveryName(this.create.delivery);
      this.getTotal();

      //设置打印分页显示信息
      this.changepage();
    },


    /** 打印 **/
    printContent() {
      this.createSave();
      var div_print = document.getElementById('printContent');
      var newStr = div_print.innerHTML;
      var oldStr = document.body.innerHTML;
      document.body.innerHTML = newStr;
      window.print();
      document.body.innerHTML = oldStr;
      location.reload();
    },


    /** 获取打印模板设置 **/
    getprintsmodel() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'getmodelsetting', id: 3, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.printsmodel = JSON.parse(Base64.decode(res.data.Data));
          
          this.rollpage = this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 修改每页条数 **/
    changepagevlaue() {
      var resource = this.$resource(this.GLOBAL.domain + "Setting/index");
      resource.query({ act: 'changepagesize', id: 90, num: this.rollpage, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.changepage();
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 设置分页设置 **/
    changepage() {
      var number = this.rollpage; //系统设置的每页条数
      this.prtotal = this.printorderdetail.goods.length; //总条数
      this.prpage = [];
      this.prollpage = [];

      if (number >= this.prtotal) {
        this.prpage.push({ id: 1 });
        this.prollpage.push({ startpage: 0, endpage: number });
        this.allprintpage = 1;
      } else {
        var tnumber = parseInt(this.prtotal / number);
        var lnumber = this.prtotal % number;
        var index;
        var start;
        var end;
        lnumber > 0 ? tnumber++ : '';
        this.allprintpage = tnumber;

        for (var i = 0; i < tnumber; i++) {
          index = i + 1;
          this.prpage.push({ id: index });
          start = i * number;
          end = index * number - 1;
          this.prollpage.push({ startpage: start, endpage: end });
        }
      }
    },


    /** 品牌搜索（品牌发生变化时触发一次搜索） **/
    selectbrand() {
      this.isnewselect = true;
      this.getProductList(this.create.send);
    },


    //展示打印确认页
    showorder(item) {
      this.getprintdetail(item.id);
    },


    //获取订单打印信息
    getprintdetail(id) {
      this.printerDialog = true;
      this.printLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getprintinfos', token: this.$cookies.get('token'), id: id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printLoading = false;
        } else {
          this.printorderdetail = JSON.parse(Base64.decode(res.data.Data));
          console.log(this.printorderdetail.goods, '商品调拨打印查看')
          //对商品进行分页设置
          var number = this.rollpage; //系统设置的每页条数
          this.prtotal = this.printorderdetail.goods.length; //总条数
          this.prpage = [];
          this.prollpage = [];

          if (number >= this.prtotal) {
            this.prpage.push({ id: 1 });
            this.prollpage.push({ startpage: 0, endpage: number });
            this.allprintpage = 1;
          } else {
            var tnumber = parseInt(this.prtotal / number);
            var lnumber = this.prtotal % number;
            var index;
            var start;
            var end;
            lnumber > 0 ? tnumber++ : '';
            this.allprintpage = tnumber;
            for (var i = 0; i < tnumber; i++) {
              index = i + 1;
              this.prpage.push({ id: index });
              start = i * number;
              end = index * number - 1;
              this.prollpage.push({ startpage: start, endpage: end });
            }
          }
          this.printLoading = false;
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
        this.printLoading = false;
      });
    },


    /** 订单信息打印 **/
    createnoSave() {
      this.printorderLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'updateprintnumber', token: this.$cookies.get('token'), id: this.printorderdetail.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.printorderLoading = false;
        } else {
          this.printlocalpage(); //打印 
        }
      }).catch((res) => {
        this.printorderLoading = false;
      });
    },

    /** 打印当前页面 **/
    printlocalpage() {
      //设置打印完成后回调页面
      this.$cookies.set('returnurlids', 'Allot');
      //保留搜索前的数据
      var data = {};
      data.orderisselect = this.orderisselect;
      data.order = this.order;
      this.$cookies.set('print_back_data_Allot', JSON.stringify(data));


      //设置打印信息
      var div_print = document.getElementById('printContent');
      var newStr = div_print.innerHTML;
      var oldStr = document.body.innerHTML;
      document.body.innerHTML = newStr;
      window.print();
      document.body.innerHTML = oldStr;
      location.reload();
    },

    /** 新增退款订单 **/
    addnews() {
      this.$emit('listenchild', { name: '新增商品调拨', url: 'Allotadd' });
      //this.getList();
      //this.addallotDialog=true;
    },


    //删除
    delCurrent(item) {
      this.$confirm('此操作将撤销 ' + item.documents + ' 调拨记录, 是否继续?', '提示', { type: 'warning' })
        .then(() => {
          // 向请求服务端删除
          var resource = this.$resource(this.url);
          resource.save({ act: 'delrecord', id: item.id, token: this.$cookies.get('token') })
            .then((res) => {
              if (res.data.Result > 0) {
                if (res.data.Result == '70001') {
                  this.$router.push('/login')
                }
                this.$message.error(res.data.Message);
              } else {
                this.$message.success('成功撤销了' + item.documents + '!');
                this.getOrderlists();
              }
            }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
            });
        })
        .catch(() => {
          this.$message.info('已取消操作!');
        });
    },

    //删除单个
    delSingleCurrent(item) {
      this.$confirm('此操作将撤销 ' + item.name + ' 调拨记录, 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'delsinglerecord', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功撤销了' + item.name + '!');
            this.getOrderlists();
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },


  }
}
</script>

</script>
<style type="text/css">
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 3% 1%
}

.titlelists {
  float: left;
  width: 100%;
  padding: 0;
  margin: 0
}

.titlelists li {
  float: left;
  width: 33.3%;
  font-size: 15px;
  list-style-type: none
}
</style>


// WEBPACK FOOTER //
// src/components/home/Allot.vue